
import axios from '../../../services/axios';


export const saveOrder = async ({companyId, cart, client, products, type}) => {
    try {
        const res = await axios.post(`/smartmenu/order/register`, {
            companyId: companyId,
            clientData: client,
            orderPrice: cart.cart_price,
            openCart: cart.datetime,
            products: products,
            type: type,
            sessionUUID: client?.sessionUUID ?? null,
        });

        if (res.status === 200) {
            return;
        }

    } catch (error) {
        console.error('ERROR - SAVE ORDER:', error);
        throw error;
    }
};